import { Component, OnInit,ViewChild,AfterViewInit  } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import { AddEcowasBusinessConfigComponent } from '../add-ecowas-business-config/add-ecowas-business-config.component';
import { DataSharingService } from 'src/app/service/data-sharing.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';


@Component({
  selector: 'app-add-rrms-live-service-configuration',
  templateUrl: './add-rrms-live-service-configuration.component.html',
  styleUrls: ['./add-rrms-live-service-configuration.component.scss']
})
export class AddRrmsLiveServiceConfigurationComponent implements OnInit {

  @ViewChild('BusinessConfig',{static:false}) ecowasBusinessConfig: AddEcowasBusinessConfigComponent;


  @ViewChild(MatStepper,{static:false}) stepper: MatStepper;
  addCountryDetailsFormGroup:FormGroup;
  addBusinessForm: FormGroup;
  addEcowasConfigForm: FormGroup;
  addOrganizationFormGroup:FormGroup;
  addProbFormGroup: FormGroup;
  addEcowasinFormGroup: FormGroup;
  allowedGtFormGroup: FormGroup;
  addCcNdcFormGroup:FormGroup;
  addMccMncFormGroup:FormGroup;
  addThresholdConfigformGroup:FormGroup;
  // ProballowedGtFormGroup:FormGroup;
  addProbDBCcNdcFormGroup:FormGroup;
  addProbdbMccMncFormGroup:FormGroup;
  addEcowasRrmsOrganizationFormGroup:FormGroup;


  submitted:boolean=false;
  submitted1:boolean=false;
  submitted2:boolean=false;

  submitted3:boolean=false;

  submitted4:boolean=false;
  submitted5:boolean=false;
  submitted6:boolean=false;
  submitted7:boolean=false;
  submitted8:boolean=false;
  submitted9:boolean=false;
  submitted10:boolean=false;
  submitted11:boolean=false;
  submitted12:boolean=false;
  submitted13:boolean=false;

  orgid:any;
  roamorgid:any;
  nType:any;
  

  country:any=['AFGHANISTAN','BENIN','CAMEROON','CONGO BRAZZAVILLE','COTE DIVOIRE','GHANA','GUINEA BISSAU','LIBERIA','NIGERIA','RWANDA','SOUTH AFRICA','SOUTH SUDAN','SUDAN','SWAZILAND','UGANDA','ZAMBIA'];
  NodeValue:any=['app1','app2','app3','app4']


  constructor(private dialog: MatDialog, private router:Router,
    private dataSharingService: DataSharingService,private formBuilder:FormBuilder , private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private spinnerService:Ng4LoadingSpinnerService,) { }

  ngOnInit(): void {
    this.addBusinessConfigForm();
    
    if(this.ecowasBusinessConfig){
      console.log("bbb",this.ecowasBusinessConfig.addBusinessForm)
    }
  
  }
 
  addBusinessConfigForm(){
    this.addBusinessForm = this.formBuilder.group({
      //orgId :['',Validators.required],
    roamOrgId : ['',Validators.required],
    //type : ['',Validators.required],
    ecowas_enabled : ['Y'],
    message_enabled :['N'],
    charging_enabled :['Y'],
    iot_signed :['N'],
    tarrif_sno : [],
    tarriff_name : [],
    // created_date : [],
    // modified_date : [],
    freeRoamValidity :['1'],
    counterValidity :['1'],
    messageInterval : ['1'],
    stayHomeInterval : ['7'],
    counterStayHomeInterval : ['1000'],
    ratesApplied : ['1'],
    moc :['1'],
    mtc:['2'],
    smsmo:['2'],
    grps:['2'],
    dataOthers:['1'],
    mocNoOfDaysApplied:['10001'],
    mtcNoOfDaysApplied:['1001'],
    smsmoNoOfDaysApplied:['1000'],
    gprsNoOfDaysApplied:['1000'],
    dataNoOfDaysApplied:['1000'],
    communityId:[],
    communityName:['ECOWAS'],
    whitelist_enabled:['Y'],
    vistingCountry:['UK'],
    vistingNetwork:['UKGEN'],
    // primaryType:[],
    // should_run_primary:[],
    // should_run_slave:[]
    })
    this.addEcowasConfig()
  }
  addEcowasConfig(){
    console.log("?????????",sessionStorage.getItem('orgIdv'))
    this.addEcowasConfigForm = this.formBuilder.group({   	
    // orgId	:['',Validators.required],
    country_name:['MTN GHANA'],	
    welcome_sms	:['Enjoy your stay. Call rates will be applied as per ecowas special tariff'],
    goodbye_sms	:['Dear Customer your ECOWAS special roaming pack is over, standard roaming rates for all calls will apply.'],
    is_active	:['Y'],
    // created_date:[],	
    // updated_date:[],	
    operator_name:[],	
    time_zone:[],	
    short_code:[],	
    reminder_sms:['Dear customer your ECOWAS special roaming offer will end in next 7 days. Standard roaming rates to apply.'],	
    mcc	:[],
    mnc	:[],
    cc:[]	

    })
    this.addOrganization();
  }
  addOrganization(){
    this.addOrganizationFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      type : ['',Validators.required],
      country_name:['Sierra Leone'],
      operator:['Airtel'],
      tadIg:[],
      mcc:[],
      mnc:[],
      cc:[],
      // created_date:[],
      ndc:[]

    })
    this.addprobe();
  }
  addprobe(){
    this.addProbFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      threadCount:['75']
    })
    this.addEcowasInCon()
  }
  addEcowasInCon(){
    this.addEcowasinFormGroup = this.formBuilder.group({
      // orgId:[sessionStorage.getItem('orgIdv')],
      // orgId:['',Validators.required],
      service_name:[],
      spId:[],
      productId:[],
      serviceId:[],
      password:['876'],
      username:['ECOWAS'],
      host:['UGW_TEST'],
      url:[],
      offerId:[],
      
      deActUrl:[],
      hlrLoginCommand:[],
      blockSmsCommand:[],
      blockInternetCommand:[],
      unblockSmsCommand:[],
      unblockInternetCommand:[],
      hlrIP:[],
      hlrPort:['3300'],
      blockInternetCommand1:[],
      unblockInternetCommand1:[],
      locCheckCmd:[]
  
    })
   this.addccNdcForm() 
  }
// addEcowasAllowedGtForm(){
//   this.allowedGtFormGroup = this.formBuilder.group({
//     // orgId:['',Validators.required],
//     gt:['',Validators.required,]
//   })
//   this.addccNdcForm()
// }
addccNdcForm(){
  this.addCcNdcFormGroup = this .formBuilder.group({
    // orgId:['',Validators.required],
    cc:['229',Validators.required],
    ndc:['98',Validators.required],
    tapCode:['',Validators.required]
   
  })
 this.addMccMncDetailsForm();
}
addMccMncDetailsForm(){
  this.addMccMncFormGroup = this.formBuilder.group({
    // orgId:['',Validators.required],
    mcc:['611',Validators.required],
    mnc:['30',Validators.required],
    tapCode:['',Validators.required]
  })
  this.addThresholdConfigForm()
}
addThresholdConfigForm(){
  this.addThresholdConfigformGroup = this.formBuilder.group({
    // orgId :['',Validators.required],
    vistingOrgId:['93',Validators.required],
    offerName:[],
    SMSThreshHoldValue:['55'],
    DataThresholdValue:['55']
  
    
  })
  this.addProbDBccndcForm();
}
// addProbDBAllowedGt(){
//   this.ProballowedGtFormGroup = this.formBuilder.group({
//     // orgId:['',Validators.required],
//     gt:['',Validators.required]
//   })
//   this.addProbDBccndcForm();
// }
addProbDBccndcForm(){
  this.addProbDBCcNdcFormGroup = this .formBuilder.group({
    // orgId:['',Validators.required],
    cc:['229',Validators.required],
    ndc:['98',Validators.required],
    tapCode:['',Validators.required]
   
  })
this.addProbdbmccMncForm()
}
addProbdbmccMncForm(){
  this.addProbdbMccMncFormGroup = this.formBuilder.group({
    // orgId:['',Validators.required],
    mcc:['611',Validators.required],
    mnc:['30',Validators.required],
    tapCode:['',Validators.required]
  })
  this.addRrmsEcowasOrganization();
}
addRrmsEcowasOrganization(){
  this.addEcowasRrmsOrganizationFormGroup = this.formBuilder.group({
//  orgId:['',Validators.required],
    country_name:[],
    operator:[],
    tadIg:[],
    mcc:['611'],
    mnc:['30'],
    cc:['229'],
    ndc:['98'],
  })
  this.addCountryDetailsForm();
}

  addCountryDetailsForm(){
    this.addCountryDetailsFormGroup = this.formBuilder.group({
      // orgId :['',Validators.required],
      country:['',Validators.required],
      MSISDN:['',Validators.required],
      // roamOrgId:['',Validators.required],
      // type:['',Validators.required]
      gt:['',Validators.required]
    })
  }
  get f(){
   return this.addBusinessForm.controls;
   
  }
  get g(){
    return this.addEcowasConfigForm.controls;
  }
  get h(){
    return this.addOrganizationFormGroup.controls;
  }
  get i(){
    return this.addProbFormGroup.controls;
  }
  get j(){
    return this.addEcowasinFormGroup.controls;
  }
  get k(){
    return this.addCountryDetailsFormGroup.controls;
  }
  get m(){
    return this.allowedGtFormGroup.controls;
  }
  get n(){
    return this.addCcNdcFormGroup.controls;
  }
  get p(){
    return this.addMccMncFormGroup.controls;
  }
  get q(){
    return this.addThresholdConfigformGroup.controls;
  }
  // get r(){
  //   return this.ProballowedGtFormGroup.controls;
  // }
  get s(){
    return this.addProbDBCcNdcFormGroup.controls;
  }
  get t(){
    return this.addProbdbMccMncFormGroup.controls;
  }
  get u(){
    return this.addEcowasRrmsOrganizationFormGroup.controls;
  }

  onAddCountryDetails(){
    this.submitted5=true;
 
    if (this.addCountryDetailsFormGroup.invalid) {
     return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_COUNTRYDATA + 
      '&orgId=' + this.orgid + 
      '&roamOrgId=' + this.roamorgid +
      '&msisdn=' + this.addCountryDetailsFormGroup.get('MSISDN').value +
      '&country=' + this.addCountryDetailsFormGroup.get('country').value +
      '&table=rrms_live_mapping_copy' + '&gt=' + this.addCountryDetailsFormGroup.get('gt').value + 
      '&type=' + this.nType +
      '&created_by=' + sessionStorage.getItem('ecowas_user_name')
      )
      .subscribe(response => {
        console.log("response",response)
        alert('Service Added successfully');        
         this.spinnerService.show();
         this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard']).then()
      })
  }
  onAdd2(){
    this.submitted2=true;
    if(this.addOrganizationFormGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_ORGANIZATION_CONFIG +
      // '&orgId=' + this.orgid + 
      '&type=' + this.addOrganizationFormGroup.get('type').value +
      '&country_name=' + this.addOrganizationFormGroup.get('country_name').value+
      '&operator=' + this.addOrganizationFormGroup.get('operator').value+
      '&tadIg=' + this.addOrganizationFormGroup.get('tadIg').value+
      '&mcc=' + this.addOrganizationFormGroup.get('mcc').value+
      '&mnc=' + this.addOrganizationFormGroup.get('mnc').value+
      '&cc=' + this.addOrganizationFormGroup.get('cc').value+
      // '&created_date=' + this.addOrganizationFormGroup.get('created_date').value+
      '&ndc=' + this.addOrganizationFormGroup.get('ndc').value
     

      )
      .subscribe(response => {
        console.log("responseeee",response);
        this.orgid=response[0].orgId;
        console.log("orgid",this.orgid)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Add successfully');        
      //   this.spinnerService.show();
       
      // }
  })
 }
  onAdd(){
    console.log('hii');
    this.submitted=true;
 
 if (this.addBusinessForm.invalid) {
  return;
 }
//  this.orgid=this.addBusinessForm.get('orgId').value;
//  console.log("aaa",this.orgid)
// this.stepper.next();
// this.orgIdData =this.addBusinessForm.get('orgId').value;
 // this.addBusinessForm.get('orgId').setValue( this.addBusinessForm.get('orgId').value);
   this.backendApiService.callToApi(this.endpointsService.URL_ADD_BUSINESS_CONFIG +
     '&orgId=' + this.orgid+
     '&roamOrgId=' + this.addBusinessForm.get('roamOrgId').value+
     '&ecowas_enabled=' + this.addBusinessForm.get('ecowas_enabled').value+
     '&message_enabled=' + this.addBusinessForm.get('message_enabled').value+
     '&charging_enabled=' + this.addBusinessForm.get('charging_enabled').value+
     '&iot_signed=' + this.addBusinessForm.get('iot_signed').value+
     '&tarrif_sno=' + this.addBusinessForm.get('tarrif_sno').value+
     '&tarriff_name=' + this.addBusinessForm.get('tarriff_name').value+
     '&freeRoamValidity=' + this.addBusinessForm.get('freeRoamValidity').value+
     '&counterValidity=' + this.addBusinessForm.get('counterValidity').value+
     '&messageInterval=' + this.addBusinessForm.get('messageInterval').value+
     '&stayHomeInterval=' + this.addBusinessForm.get('stayHomeInterval').value+
     '&counterStayHomeInterval=' + this.addBusinessForm.get('counterStayHomeInterval').value+
     '&ratesApplied=' + this.addBusinessForm.get('ratesApplied').value+
     '&moc=' + this.addBusinessForm.get('moc').value+
     '&mtc=' + this.addBusinessForm.get('mtc').value+
     '&smsmo=' + this.addBusinessForm.get('smsmo').value+
     '&grps=' + this.addBusinessForm.get('grps').value+
     '&dataOthers=' + this.addBusinessForm.get('dataOthers').value+
     '&mocNoOfDaysApplied=' + this.addBusinessForm.get('mocNoOfDaysApplied').value+
     '&mtcNoOfDaysApplied=' + this.addBusinessForm.get('mtcNoOfDaysApplied').value+
     '&smsmoNoOfDaysApplied=' + this.addBusinessForm.get('smsmoNoOfDaysApplied').value+
     '&gprsNoOfDaysApplied=' + this.addBusinessForm.get('gprsNoOfDaysApplied').value+
     '&dataNoOfDaysApplied=' + this.addBusinessForm.get('dataNoOfDaysApplied').value+
     '&communityId=' + this.addBusinessForm.get('communityId').value+
     '&communityName=' + this.addBusinessForm.get('communityName').value+
     '&whitelist_enabled=' + this.addBusinessForm.get('whitelist_enabled').value+
     '&vistingCountry=' + this.addBusinessForm.get('vistingCountry').value+
     '&vistingNetwork=' + this.addBusinessForm.get('vistingNetwork').value+
    //  +'&primaryType=' + this.addBusinessForm.get('primaryType').value+
    //  '&should_run_primary=' + this.addBusinessForm.get('should_run_primary').value+
    //  '&should_run_slave=' + this.addBusinessForm.get('should_run_slave').value+
     '&type=' + this.nType 
    
     
     

     )
     .subscribe(response => {
       console.log("responseeee",response)
 //       if (response === null || response === false ) {
 //         alert('Not Added');
 //         return;
 //       }
 //       else if(response === '{\"status\": \"Record with orgId already exists\"}'){
 //         alert("Record with orgid already exit")
 //       }
 //        else {
 //         alert('Add successfully');        
 //         this.spinnerService.show();
 //sessionStorage.setItem('orgIdv',this.addBusinessForm.get('orgId').value );
 //       }
  })
 }
 onAdd1(){
  this.submitted1=true;
    if(this.addEcowasConfigForm.invalid){
      return;
    }
    console.log("aaa",this.orgid)
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_CONFIG +
      '&orgId=' + this.orgid + '&type=' + this.nType +
      '&country_name=' + this.addEcowasConfigForm.get('country_name').value+
      '&welcome_sms=' + this.addEcowasConfigForm.get('welcome_sms').value+
      '&goodbye_sms=' + this.addEcowasConfigForm.get('goodbye_sms').value+
      '&is_active=' + this.addEcowasConfigForm.get('is_active').value+
      // '&created_date=' + this.addEcowasConfigForm.get('created_date').value+
      // '&updated_date=' + this.addEcowasConfigForm.get('updated_date').value+
      '&operator_name=' + this.addEcowasConfigForm.get('operator_name').value+
      '&time_zone=' + this.addEcowasConfigForm.get('time_zone').value+
      '&short_code=' + this.addEcowasConfigForm.get('short_code').value+
      '&reminder_sms=' + this.addEcowasConfigForm.get('reminder_sms').value+
      '&mcc=' + this.addEcowasConfigForm.get('mcc').value+
      '&mnc=' + this.addEcowasConfigForm.get('mnc').value+
      '&cc=' + this.addEcowasConfigForm.get('cc').value
     

      )
      .subscribe(response => {
        console.log("responseeee",response)
        // if (response === null  || response === '{"status" : "false"}') {
        //   alert('Not Added');
          

        //   return;
        // }
        // else if( response === '{"status" : "Record with orgId already exists"}'){
        //   alert("Record with orgid already exit")
        // }
        //  else {
        //   alert('Added successfully');        
        //   this.spinnerService.show();
         
        // }
  })
 }
 
 onAdd3(){
  this.submitted3=true;
  if(this.addProbFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_PROBE_CONFIG +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&threadCount=' + this.addProbFormGroup.get('threadCount').value
    
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Added successfully');        
      //   this.spinnerService.show();
       
      // }
})
 }
 onAdd4(){
   this.submitted4=true;
  if(this.addEcowasinFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_IN_CONFIG +
    '&service_name=' + this.addEcowasinFormGroup.get('service_name').value+
    '&spId=' + this.addEcowasinFormGroup.get('spId').value+
    '&productId=' + this.addEcowasinFormGroup.get('productId').value+
    '&serviceId=' + this.addEcowasinFormGroup.get('serviceId').value+
    '&password=' + this.addEcowasinFormGroup.get('password').value+
    '&username=' + this.addEcowasinFormGroup.get('username').value+
    '&host=' + this.addEcowasinFormGroup.get('host').value+
    '&url=' + this.addEcowasinFormGroup.get('url').value+
    '&offerId=' + this.addEcowasinFormGroup.get('offerId').value+
    '&orgId=' + this.orgid +  '&type=' + this.nType +
    '&deActUrl=' + this.addEcowasinFormGroup.get('deActUrl').value+
    '&hlrLoginCommand=' + this.addEcowasinFormGroup.get('hlrLoginCommand').value+
    '&blockSmsCommand=' + this.addEcowasinFormGroup.get('blockSmsCommand').value+
    '&blockInternetCommand=' + this.addEcowasinFormGroup.get('blockInternetCommand').value+
    '&unblockSmsCommand=' + this.addEcowasinFormGroup.get('unblockSmsCommand').value+
    '&unblockInternetCommand=' + this.addEcowasinFormGroup.get('unblockInternetCommand').value+
    '&hlrIP=' + this.addEcowasinFormGroup.get('hlrIP').value+
    '&hlrPort=' + this.addEcowasinFormGroup.get('hlrPort').value+
    '&blockInternetCommand1=' + this.addEcowasinFormGroup.get('blockInternetCommand1').value+
    '&unblockInternetCommand1=' + this.addEcowasinFormGroup.get('unblockInternetCommand1').value+
    '&locCheckCmd=' + this.addEcowasinFormGroup.get('locCheckCmd').value
    
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
      // if (response === null  || response === '{"status" : "false"}') {
      //   alert('Not Added');
        

      //   return;
      // }
      // else if( response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }else {
        // alert('Service Added successfully');        
        // this.spinnerService.show();
        // this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard']).then()
    //  }
})
 }
//  onAdd5(){
//   console.log("oooooo")
//   this.submitted6=true;
//   if(this.allowedGtFormGroup.invalid){
//     return;
//   }
//   this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_ALLOWED_GT +
//     '&orgId=' + this.orgid + '&type=' + this.nType +
//     '&gt=' + this.allowedGtFormGroup .get('gt').value
   

//     )
//     .subscribe(response => {
//       console.log("responseeee",response)
//     // if (response === null || response === false ) {
//     //   alert('Not Added');
//     //   return;
//     // }
//     // else if(response === '{"status" : "Record with orgId already exists"}'){
//     //   alert("Record with orgid already exit")
//     // }
//     //  else {
//     //   alert('Add successfully');        
//     //   this.spinnerService.show();
     
//     // }
// })
//  }
 onAdd6(){
  this.submitted7=true;
  if(this.addCcNdcFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOEAS_CC_NDC +
    '&orgId=' + this.orgid + '&type=' + this.nType + 
    '&cc=' + this.addCcNdcFormGroup .get('cc').value+
    '&ndc=' + this.addCcNdcFormGroup .get('ndc').value+
    '&tapCode=' + this.addCcNdcFormGroup .get('tapCode').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }
 onAdd7(){
  this.submitted8=true;
  if(this.addMccMncFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_MCC_MNC +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&mcc=' + this.addMccMncFormGroup .get('mcc').value+
    '&mnc=' + this.addMccMncFormGroup .get('mnc').value+
    '&tapCode=' + this.addMccMncFormGroup .get('tapCode').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }
 onAdd8(){
  this.submitted9=true;
  if(this.addThresholdConfigformGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_THRESHOLD_CONFIG +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&roamOrgId=' + this.addThresholdConfigformGroup .get('vistingOrgId').value+
    '&offerName=' + this.addThresholdConfigformGroup .get('offerName').value+
    '&SMSThreshHoldValue=' + this.addThresholdConfigformGroup .get('SMSThreshHoldValue').value+
    '&DataThresholdValue=' + this.addThresholdConfigformGroup .get('DataThresholdValue').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }
//  onAdd9(){
//   this.submitted10=true;
//   if(this.ProballowedGtFormGroup.invalid){
//     return;
//   }
//   this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBRDB_ALLOWED_GT +
//     '&orgId=' + this.orgid + '&type=' + this.nType +
//     '&gt=' + this.ProballowedGtFormGroup .get('gt').value
    
   

//     )
//     .subscribe(response => {
//       console.log("responseeee",response)
// })
//  }
 onAdd10(){
  this.submitted11=true;
  if(this.addProbDBCcNdcFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBDB_CC_NDC +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&cc=' + this.addProbDBCcNdcFormGroup .get('cc').value+
    '&ndc=' + this.addProbDBCcNdcFormGroup .get('ndc').value+
    '&tapCode=' + this.addProbDBCcNdcFormGroup .get('tapCode').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }
 onAdd11(){
  this.submitted12=true;
  if(this.addProbdbMccMncFormGroup.invalid){
    return;
  }
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBDB_MCC_MNC +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&mcc=' + this.addProbdbMccMncFormGroup .get('mcc').value+
    '&mnc=' + this.addProbdbMccMncFormGroup .get('mnc').value+
    '&tapCode=' + this.addProbdbMccMncFormGroup .get('tapCode').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }
 onAdd12(){
  this.submitted13=true;
  if(this.addEcowasRrmsOrganizationFormGroup.invalid){
    return;
  }
  
  
  this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBDB_ORGANIZATION +
    '&orgId=' + this.orgid + '&type=' + this.nType +
    '&country_name=' + this.addEcowasRrmsOrganizationFormGroup .get('country_name').value+
    '&operator=' + this.addEcowasRrmsOrganizationFormGroup .get('operator').value+
    '&tadIg=' + this.addEcowasRrmsOrganizationFormGroup .get('tadIg').value+
    '&mcc=' + this.addEcowasRrmsOrganizationFormGroup .get('mcc').value+
    '&mnc=' + this.addEcowasRrmsOrganizationFormGroup .get('mnc').value+
    '&cc=' + this.addEcowasRrmsOrganizationFormGroup .get('cc').value+
    '&ndc=' + this.addEcowasRrmsOrganizationFormGroup .get('ndc').value
   

    )
    .subscribe(response => {
      console.log("responseeee",response)
})
 }

  goBckword(){
    this.router.navigate(['/service-live-dashboard/rrms-service-live-dashboard']).then()
   
  }
  AfterViewInit(){
    if(this.ecowasBusinessConfig){
      console.log("bbb",this.ecowasBusinessConfig.addBusinessForm)
    }
  }

}
